//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../no/Sketch.js";
let d=[[[0,"ConstraintSymbolSize",1,0],[0,"ContinuousAutoDimensioningSetting",1,0],[0,"CreateInferredConstraints",1,0],[0,"DimensionLabel",1,0],[0,"DimensionTextScale",1,0],[0,"DisplayObjectColor",1,0],[0,"DisplayObjectName",1,0],[0,"DisplayParenthesesOnReferenceDimensions",1,0],[0,"DisplayReferenceGeometry",1,0],[0,"DisplayShadedRegions",1,0],[0,"DisplayVertices",1,0],[0,"FixedTextSize",1,0],[0,"SolvingTolerance",1,0],[0,"TextSizeFixed",1,1],[0,"TextSizeMode",1,0],[0,"UseSolvingTolerance",1,0]],[[["dim_display_flag"],"ApplySketchPreferences",{},1,0]],[]];
SPLM.Preferences.SketchPreferences = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.SketchPreferences";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.SketchPreferences.DimensionLabelType = Object.freeze({
    "Expression" : "Expression", "Name" : "Name", "Value" : "Value"});

SPLM.Preferences.SketchPreferences.DimensionTextSizeMode = Object.freeze({
    "DraftingStandard" : "DraftingStandard", "FixedOnScreen" : "FixedOnScreen", "Variable" : "Variable"});

export default SPLM;